import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie';
import { Home, Careers, AboutUs, Industries, ContactUs, Services, CaseStudies, PrivacyPolicy, NewsletterUnsubscribe } from './pages'
import Header from './components/Header'
import Footer from './components/Footer'
import CookiesConsent from './components/modals/CookiesConsent'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fortawesome/fontawesome-free/css/all.min.css'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route path="/" element={<Home />} />,
      <Route path="/careers" element={<Careers />} />,
      <Route path="/services" element={<Services />} />,
      <Route path="/about-us" element={<AboutUs />} />,
      <Route path="/industries" element={<Industries />} />,
      <Route path="/contact" element={<ContactUs />} />,
      <Route path="/case-studies" element={<CaseStudies />} />,
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />,
      <Route path="/unsubscribe/:sf?" element={<NewsletterUnsubscribe />} />,
    </Route>
  )
)

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <CookiesProvider>
        <div id='modal-responses'></div>
        <CookiesConsent />
        <Header />
        <RouterProvider router={router} />
        <Footer />
      </CookiesProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
